import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=202ee72f&scoped=true&"
import script from "./import-file.vue?vue&type=script&lang=js&"
export * from "./import-file.vue?vue&type=script&lang=js&"
import style0 from "./import-file.vue?vue&type=style&index=0&id=202ee72f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ee72f",
  null
  
)

export default component.exports